var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" You're authenticated now. Please close the window to return. ")])}
var staticRenderFns = []

export { render, staticRenderFns }